jQuery(function($) {
  $('.print').click(function() {
    window.print()
  });
});